<template>
  <form-wizard
    ref="refFormWizard"
    color="#7367F0"
    :title="null"
    :subtitle="null"
    finish-button-text="Submit"
    back-button-text="Previous"
    hide-buttons
    class="checkout-form-wizard steps-transparent"
  >
    <!-- account detail tab -->
     <!-- <tab-content title="ثبت نام یا ورود" icon="feather icon-user">
       <invoice-login />
    </tab-content> -->
    <tab-content title="نمایش فاکتور" icon="feather icon-list">
      <invoice-detail />
    </tab-content>

    <!-- address -->
    <!-- <tab-content
      title="Address"
      icon="feather icon-home"
    >
      <e-commerce-checkout-step-address
        :address-details="checkoutDetails.address"
        @next-step="formWizardNextStep"
      />
    </tab-content> -->

    <!-- social link -->
    <!-- <tab-content
      title="Payment"
      icon="feather icon-credit-card"
    >
      <e-commerce-checkout-step-payment
        :payment-details="checkoutDetails.payment"
        @next-step="formWizardNextStep"
      />
    </tab-content> -->
  </form-wizard>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import InvoiceDetail from "./invoice-detail/InvoiceDetail.vue";
import InvoiceLogin from "./invoice-login/InvoiceLogin.vue";


export default {
  components: {
    FormWizard,
    TabContent,
    InvoiceLogin,
    InvoiceDetail,
  },

};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "~@core/scss/base/pages/app-ecommerce.scss";
@import "~vue-form-wizard/dist/vue-form-wizard.min.css";
</style>

<style lang="scss" scoped>
.checkout-form-wizard ::v-deep {
  .wizard-tab-content {
    box-shadow: none !important;
    background: transparent !important;
    padding: 0;
  }
}
</style>
